<template>
  <div
    :class="['notion-icon', icon.type === 'emoji' ? '-emoji' : '-icon']"
    :style="wrapperStyle"
  >
    <span
      v-if="icon.type === 'emoji'"
      :aria-label="icon.emoji"
      class="_inner"
    >{{ icon.emoji }}</span>
    <img
      v-else
      :style="imgStyle"
      :src="url"
      referrerpolicy="no-referrer"
    >
  </div>
</template>

<script>
export default {
  name: 'NotionIcon',
  props: {
    icon: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  data() {
    return { hover: false };
  },
  computed: {
    wrapperStyle() {
      const style = { width: `${this.size / 10}rem`, height: `${this.size / 10}rem` };
      if (this.icon.type === 'emoji') {
        style.fontSize = `${this.size / 10}rem`;
        return style;
      }
      return style;
    },
    url() {
      if (this.icon.type === 'file') {
        return this.icon.file.url;
      }
      if (this.icon.type !== 'external') {
        return '';
      }
      if (this.icon.external.url.indexOf('https') === -1) {
        return `https://notion.so/${this.icon.external.url}`;
      }
      return this.icon.external.url;
    },
    imgStyle() {
      return { width: 'inherit', height: 'inherit' };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
.notion-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  &.-emoji {
    font-family: "Apple Color Emoji", "Segoe UI Emoji", NotoColorEmoji, "Noto Color Emoji", "Segoe UI Symbol", "Android Emoji", EmojiSymbols, sans-serif;
  }
}
</style>
